import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html'
})
export class ComingSoonComponent implements OnInit {

  constructor() { }

  gotoBack() {
    window.history.back();
  }
  ngOnInit() {
  }

}
